/**
 * LED pattern utilities shared between the 3D renderer and price calculators.
 *
 * Pattern format:  "3-2-3"  or  "3x3"
 *   - Each number = how many LED spots on that beam position
 *   - The pattern repeats across all internal beams (beams 1 … N-2)
 *
 * Example:  breedte=600 → numberOfBeams = ceil(600/80) = 8 → 6 internal beams
 *   pattern "3-2-3" → spots per beam: [3, 2, 3, 3, 2, 3] → total = 16
 */

/**
 * Parse a pattern string into an array of spot-counts.
 * @param {string} patternStr  e.g. "3-2-3", "2-2-2-2", "3x3"
 * @returns {number[]}  e.g. [3, 2, 3]
 */
export const parseLedPattern = (patternStr) => {
    if (!patternStr || patternStr === 'Geen') return [];
    const parts = patternStr.split(/x|-/i).map(Number).filter(n => !isNaN(n) && n > 0);
    return parts;
};

/**
 * Count the total LED spots for a given breedte and pattern.
 * @param {number} breedte  Veranda width in cm
 * @param {string} patternStr  LED pattern name, e.g. "3-2-3"
 * @returns {number}  Total LED spot count
 */
export const countLedSpots = (breedte, patternStr) => {
    const beamLeds = parseLedPattern(patternStr);
    if (beamLeds.length === 0) return 0;

    const numberOfBeams = Math.ceil(breedte / 80);
    const internalCount = Math.max(0, numberOfBeams - 2);

    let total = 0;
    for (let i = 0; i < internalCount; i++) {
        total += beamLeds[i % beamLeds.length];
    }
    return total;
};
